// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___3QLxz","flex":"flex___32mxb","label":"label___3zH-9"};